import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, InspectionPlugin, Icons } from '../../shared/models/index';
import { StatesPluginService } from './states-plugin.service';
import { BasePlugin } from '../base-plugin.component';
import { Impact } from './impact.model';

@Component({
    templateUrl: './states.component.html',
    standalone: false
})
export class StatesPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;

  public impactsValues: any;
  public impact = new Impact();

  public showPriority = false;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef, private service: StatesPluginService) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.initData();
    this.cdRef.detectChanges();
  }

  initData() {
    this.impactsValues = this.service.getImpacts();
    if (this.plugin && this.plugin.config) {
      this.impact.initImpactValue(this.plugin.config.Impact);
      this.showPriority =
        (this.plugin.config.Priority === 0 || this.plugin.config.Priority) && this.plugin.config.Priority >= 0;
    }
  }

  getImpactValue() {
    let impactValue = '';
    let isFirst = true;
    this.impactsValues.forEach((v) => {
      if (this.impact.getImpactValue(v.value)) {
        if (isFirst) {
          impactValue = v.label;
          isFirst = false;
        } else {
          impactValue = `${impactValue}, ${v.label}`;
        }
      }
    });
    return impactValue;
  }

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'states',
      'edit'
    ];
  }
}

PluginComponent.plugins['states'] = StatesPluginComponent;
PluginComponent.initializers['states'] = (plugin: InspectionPlugin) => {
  if (plugin.config != null && plugin.config.Criticaly) {
    const point = plugin.inspection.pointsById[plugin.pointId];
    if (point !== undefined && point !== null) {
      Icons.initIcon(point, Icons.getIconByName(Icons.statesIconName));
    }
  }
};
